<template>
  <div class="videoH_bx" @click="hideBx">
    <video
      @click.stop="
        () => {
          return false;
        }
      "
      ref="video_b"
      playsinline
      playsinlinex5-video-player-type="h5"
      x5-video-player-fullscreen="true"
      x5-playsinline="true"
      x-webkit-airplay="allow"
      x5-video-orientation="landscape|portrait"
      style="object-fit: fill"
      webkit-playsinline="true"
      x5-video-player-type="h5-page"
      controls
    ></video>
  </div>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: "",
    },
  },
  methods: {
    hideBx() {
      this.$emit("hide");
    },
  },
  watch: {
    url(n, o) {
      if (n != "") {
        this.$refs.video_b.src = n;
        this.$refs.video_b.play();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.videoH_bx {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  video {
    width: 100%;
    height: auto;
  }
}
</style>
